import { createContext, useState } from "react";
import ContractService from "services/contract.service";

export const ContractContext = createContext({});

export function ContractProvider({ children }) {
  const [contracts, setContracts] = useState([]);
  const [loading, setLoading] = useState(false);

  // Carrega todos os contratos
  const loadContracts = async () => {
    setLoading(true);
    try {
      const response = await ContractService.getAll();
      // HttpService retorna dados diretamente, não wrapped em { data: ... }
      const contracts = Array.isArray(response) ? response : response.data || response;
      setContracts(contracts);
    } finally {
      setLoading(false);
    }
  };

  // Retorna contrato pelo evento
  const getByEvent = (eventId) => {
    return contracts.find(
      (contract) => Number(contract.event_id) === Number(eventId)
    );
  };

  const loadContractByEvent = async (eventId) => {
    try {
      console.log('[ContractContext] loadContractByEvent called with eventId:', eventId);
      const response = await ContractService.getByEvent(eventId);
      console.log('[ContractContext] API response:', response);
      
      // HttpService retorna dados diretamente, não em response.data
      const contract = response && typeof response === 'object' && response.id ? response : null;
      
      if (!contract) {
        console.log('[ContractContext] No contract data received');
        return null;
      }

      console.log('[ContractContext] Contract data:', contract);
      
      // Atualizar estado e RETORNAR o contrato
      setContracts((prev) => {
        const filtered = prev.filter(
          (c) => Number(c.event_id) !== Number(eventId)
        );
        return [...filtered, contract];
      });
      
      return contract;
    } catch (e) {
      console.log('[ContractContext] Error loading contract:', e);
      // silencioso de propósito (evento pode não ter contrato)
      return null;
    }
  };


  // Cria contrato
  const createContract = async (payload) => {
    const response = await ContractService.create(payload);
    // HttpService retorna dados diretamente
    const contract = response && typeof response === 'object' && response.id ? response : response;
    setContracts((prev) => [...prev, contract]);
    return contract;
  };


  // Atualiza contrato
  const updateContract = async (id, payload) => {
    const response = await ContractService.update(id, payload);
    // HttpService retorna dados diretamente
    const contract = response && typeof response === 'object' && response.id ? response : response;
    setContracts((prev) =>
      prev.map((c) => (c.id === id ? contract : c))
    );
    return contract;
  };

  // Assina contrato
  const signContract = async (id) => {
    const response = await ContractService.sign(id);
    // HttpService retorna dados diretamente
    const contract = response && typeof response === 'object' && response.id ? response : response;
    setContracts((prev) =>
      prev.map((c) => (c.id === id ? contract : c))
    );
    return contract;
  };

  // Cancela contrato
  const cancelContract = async (id) => {
    const response = await ContractService.cancel(id);
    // HttpService retorna dados diretamente
    const contract = response && typeof response === 'object' && response.id ? response : response;
    setContracts((prev) =>
      prev.map((c) => (c.id === id ? contract : c))
    );
    return contract;
  };

  return (
    <ContractContext.Provider
      value={{
        contracts,
        loading,
        loadContracts,
        loadContractByEvent,
        getByEvent,
        createContract,
        updateContract,
        signContract,
        cancelContract,
      }}
    >
      {children}
    </ContractContext.Provider>
  );
}
